module.exports = __webpack_public_path__ + "img/image1.fd449bdc.png";